export default {
  button: {
    edit: '编辑',
    modify: '修改',
    return: '返回',
    add: '添加',
    addBan: '添加封禁账户',
    del: '删除',
    authorization: '授权',
    secret: '修改 Google 密钥',
    resetSecret: '重置 Google 密钥',
    delMessage: '确定删除吗？',
    modifyMessage: '确定修改吗？',
    cancel: '不了',
    confirm: '是的',
    save: '保存',
    ordinary: '普通版',
    speed: '极速版',
    batchNotify: '批量通知',
    empty: '清空',
    close: '关闭',
    jump: '确认跳转',
    query: '查询',
    jumpMerchant: '跳转',
    config: '配置',
    breaker: '关闭警告',
    refresh: '清除缓存',
    share: '分享',
    version: '历史版本',
    sendMes: '发送消息',
    batchCollect: '批量归集',
    productConfig: '收银台配置',
    sendGroupMes: '设置发送的群消息',
    submit: '提交',
    setTimeZone: '设置货币时区',
    UnderstandProduct: '了解产品',
    delImg: '删除图片',
    preview: '预览图片',
    clearCount: '清除计数',
    info: '信息',
    reset: '重置机器人',
    bind: '绑定机器人',
    copy: '复制',
    upload: '上传',
    refund: '一键退款',
    export: '交易导出',
    notification: '一键通知',
    configuration: '修改配置',
    detele: '删除自定义',
    rate: '结算金额百分比',
    type: '结算类型',
    cycle: '结算周期',
    time: '时间单位',
    batchReview: '批量审核',
    start: '开启',
    none: '不设置',
    sig: '申请多签',
    callback: '回调',
    Deprecated: '作废',
    batchDisable: '批量停用',
    batchRestart: '批量重启',
    invert: '过滤商户号',
    newRate: '手续费',
    refund1: '退款',
    rolling:'循环保证金'
  },
  batch: {
    limitRange: '限制范围',
    min_amount: '最小金额',
    max_amount: '最大金额',
    batchEdit: '批量编辑',
    limited: '每⽇限定交易笔数',
    del: '批量删除',
    delAccounts: '账户名称',
    description: '描述',
    googleCode: '谷歌验证码',
    allNotice: '通知当前产品内的所有账户，请谨慎操作',
    refund: '批量退款',
    errList: '退款失败订单列表',
    msg: '错误说明',
    enable: '批量启用',
    errText: '最多200个订单批量代付操作',
    checkUpload: '编辑可用时间请勾选'
  },
  endMessage: {
    send: '发送群消息',
    group: 'Telegram 群组',
    tGroup: '群组',
    text: '文本',
    photo: '图片',
    video: '视频',
    upload: '上传图片',
    select: '消息类型',
    textArea: '消息内容',
    all: '全选',
    groupSearch: '输入群分类查询群组',
    boundGroup: '已绑定群',
    management: '管理',
    groupList: '群列表',
    groupName: '群名称',
    groupId: '群ID',
    forward_chat_id: '转发群 ID',
    forward_extra_text: '转发备注',
    permission: '群消息权限',
    deactivate: '停用',
    information: '编辑群信息',
    bot_type: '查单类型',
    deleteVideo: '删除视频',
    classification: '群分类',
    classify: '分类',
    name: '分类名称',
    description: '分类描述',
    Send: '发送',
    addType: '新增群分类',
    editType: '编辑群分类',
    comds: '指令',
    order_list: '指令列表',
    default: '默认',
    defined: '自定义',
    confirm: '确认编辑'
  },
  time: {
    halfhHour: '最近半小时',
    oneHour: '最近一小时',
    fourHour: '最近四小时',
    yesterday: '昨天',
    lastMonth: '上月',
    aWeek: '最近一周',
    aMonth: '最近一个月',
    threeMonths: '最近三个月',
    five: '五分钟',
    ten: '十分钟'
  },
  jump: {
    jump: '是否需要跳转到 H5 后台页面'
  },
  page: {
    prev: '上页',
    next: '下页'
  },
  upload: {
    tips: '可将文件拖到此处'
  },
  tag: {
    approve: '批准',
    reject: '拒绝',
    wait: '待审核'
  },
  table: {
    username: '用户名',
    password: '密码',
    email: '电子邮件',
    ip_whiteList: 'IP白名单 ',
    task_description: '任务描述',
    manager_type: '管理人员类型',
    total: '总计',
    successful_volume: '成功的金额',
    successful_ransaction: '交易成功',
    success_amount: '成功金额',
    pending_amount: '在途金额',
    pending_transaction: '在途笔数',
    approval_amount: '审批金额',
    approval_transaction: '审批交易 ',
    reject_amount: '拒绝金额',
    reject_transaction: '拒绝交易',
    transaction: '交易笔数',
    volume: '金额',
    dealVolume: '交易量',
    successful_rate: '成功率',
    today: '今天',
    notify_status: '通知商户状态',
    product_name: '产品名称 ',
    product_code: '产品',
    product_account: '产品账户',
    upstream_ordernumber: '账户订单号',
    min_amount: '最低金额',
    max_amount: '最大金额',
    notify_time: '通知时间',
    notify_start_time: '通知开始时间',
    notify_end_time: '通知结束时间 ',
    source: '订单发源地 ',
    backoffice_payout: '后台支付',
    id: 'ID',
    currency: '货币',
    merchant_ref: '商户订单号',
    systemRef: '平台订单号',
    system_ref: '平台订单号',
    requset_amount: '请求金额',
    paid_amount: '实际支付金额',
    product: '产品',
    order_status: '订单状态 ',
    title: '标题 ',
    description: '描述',
    bank: '银行 ',
    remarks: '备注',
    reason: '原因',
    order_number: '订单号',
    account_name: '收款人',
    account_no: '收款卡号',
    status: '状态',
    platformStatus: '平台订单状态',
    taskStatus: '任务状态',
    created_start_time: '创建开始时间',
    created_end_time: '创建结束时间',
    insruction: '操作说明',
    bank_name: '银行名称',
    bank_code: '银行代码',
    amount: '支付金额',
    fee: '手续费',
    approved_by: '审批人',
    approved_time: '批准时间',
    created_by: '创建人',
    created_time: '创建时间',
    operation: '操作',
    bank_account: '银行账户',
    extend_params: '扩展参数',
    information: '信息',
    cause: '原因',
    before_balance: '之前的余额',
    after_balance: '之后的余额',
    sourceIP: '源 IP',
    date: '日期',
    merchant_no: '商户号',
    merchant_name: '商户名称',
    begin_balance: '日初余额',
    end_balance: '日终余额',
    startingBalance: '日初在途余额',
    endingBalance: '日终在途余额',
    type: '类型',
    dealType: '交易类型',
    change_amount: '管理员补单金额',
    change_transaction: '管理员补单笔数',
    product_type: '产品类型',
    settlementLimit: '结算类型',
    transitionLimit: '金额限制',
    transitionTime: '可用时间',
    notify: '通知',
    details: '详细说明',
    agentFee: '代理费用',
    agentNo: '上级商户号',
    commission: '佣金',
    success_transaction: '成功交易',
    review: '审查',
    address: '地址',
    coin_type: '硬币类型',
    expectStatus: '预期状态',
    attach: '附加',
    success_time: '成功时间',
    success_start_time: '成功开始时间',
    success_end_time: ' 成功结束时间',
    succeedRequestAmount: '成功请求金额',
    succeedVolume: '成功订单',
    succeedPaidAmount: '成功支付金额',
    conversionRate: '转化率',
    mode: '处理方式',
    placeholder: '填写原因，并审核',
    smsLink: '下载短信转发器',
    plugin_name: '插件名',
    lastest_version: '插件版本',
    download_link: '下载链接',
    version: '版本号',
    renew: '版本更新内容',
    reuse_address: '复用存款地址',
    reuse_address_days: '间隔天数',
    not_reuse_address: '不重复使用地址商户号',
    reuse_address_count: '可用地址数量',
    collect_by_stake: '质押归集',
    pledgeType: '质押类型',
    pledgeAccount: '质押账户',
    pledgeAddress: '质押地址',
    path: '路由',
    name: '收银台名称',
    between: '间隔天数',
    sort: '序号',
    sort_L: '序号',
    noData: '暂无数据',
    reuse_upstream_accounts: '重复使用上游帐户频率',
    walletName: '钱包名称',
    rakeBack: '下级代理当日返佣',
    login_ip: '登录IP',
    recharge_address: '充值地址'
  },
  tips: {
    tips: '提示：',
    batchPaid: '只有待处理的订单才可以支付',
    batchChange: '只有待处理的订单可以更改',
    batchUnfreeze: '只有冻结订单才能解冻',
    batchNotify: '只有未通知的订单才能被通知',
    currentSystem: '当前系统中待处理的订单总数',
    kick: '只有在队列中的订单才能踢出队列',
    path: '当前产品无法配置收银台路由',
    ipRemind: '每个输入框只能输入一个IP，多个IP无效!',
    apikeyshow: 'API 密钥已修改，请妥善保管，请勿向他人泄漏。',
    search: '通过手机号、用户名查找账户'
  },
  checkbox: {
    checkAll: '全选'
  },
  route: {
    adminMgt: '管理员管理',
    adminList: '列表',
    taskCenter: '任务中心',
    applicationTask: '管理员特殊事项申请',
    banAccount: '封禁账户',

    product: '产品',
    productManage: '产品管理',
    accountManage: '账户管理',
    walletAddress: '钱包地址',
    merchantMgt: '商户管理',
    merchantList: '商户列表',
    accountGroup: '账户组',
    antAccountGroup: '蚂蚁账户组',
    smsLog: '短信日志',
    order: '订单管理',

    dashboard: '首页',
    backToTop: '返回顶部',
    errorPages: '错误页面',
    page401: '401',
    page404: '404',
    errorLog: '错误日志',
    theme: '换肤',
    profile: '个人中心',

    log: '日志',
    loginLog: '登录日志',
    accessDevice: '访问设备管理',

    test: '测试中心',
    setting: '系统设置',
    download: '下载中心',
    appSoftware: '通道市场',

    withdrawReview: '出金审查',
    antOrderReview: '蚂蚁抢单审核',
    depositReview: '入金审查',
    exceptionTask: '异常订单',
    bankBill: '银行账单',
    upstreamBill: '上游账单',
    rechargeCurrency: '法币充值',
    subAccount: '子账户',
    smsAccount: '短信账户',
    cardAccount: '卡商账户',
    antReview: 'USDT-TRCPayout审批',
    smsManage: '商户短信',
    antRegister: '注册审批',

    orderMgt: '订单管理 ',
    deposit: '入金订单',
    payout: '代付订单',
    settlement: '结算订单',
    refund: '退款订单',
    requestLog: '请求日志',
    globalPayments: '全球付款',

    report: '报告中心 ',
    balance: '余额报告 ',
    transaction: '交易报告 ',
    rebate: '返佣报表',
    platform: '平台报表',
    upparting: '机器人上分',
    agent: '代理佣金',

    antDashboard: '首页',
    antManage: '蚂蚁管理',
    topupOrder: '充值订单',
    cashOrder: '提现订单',
    buyUOrder: '买U订单',
    shopManage: '商户管理',
    operateManage: '运营管理',
    goodsManage: '产品管理',
    operation: '运营中心',
    gcash: 'Gcash 后台管理',
    gcashAccount: 'Gcash 账户管理',
    gcashGroups: 'Gcash 分组管理',
    exchangeOrder: '承兑订单'
  },
  navbar: {
    logOut: '退出登录',
    dashboard: '首页',
    size: '布局大小',
    return: '返回应用面板'
  },
  login: {
    title: '系统登录',
    logIn: '登录',
    username: '账号',
    password: '密码',
    code: '请输入验证码',
    any: '随便填',
    thirdparty: '第三方登录',
    thirdpartyTips: '本地不能模拟，请结合自己业务进行模拟！！！'
  },
  admin: {
    ip: '0.0.0.0表示未设置限制。',
    password: '若需修改则输出；否则无需输入',
    authMgt: '授权管理',
    module: '模块',
    menu: '菜单',
    function: '功能',
    example: '示例'
  },
  tagsView: {
    refresh: '刷新',
    close: '关闭',
    closeOthers: '关闭其它',
    closeAll: '关闭所有'
  },
  settings: {
    title: '系统布局配置',
    theme: '主题色',
    showTagsView: '显示 Tags-View',
    showSidebarLogo: '显示侧边栏 Logo',
    fixedHeader: '固定 Header',
    sidebarTextTheme: '侧边栏文字主题色'
  },
  task: {
    applicationTask: {
      created_by_name: '创建人',
      approved_by_name: '审核人',
      time: '时间',
      start_time: '起始时间',
      end_time: '结束时间',
      handle_time: '响应时间',
      begin_handle_time: '起始响应时间',
      end_handle_time: '终止响应时间',
      status: '审核状态',
      status0: '待审核',
      status1: '批准',
      status2: '拒绝'
    }
  },
  // ------------- 新翻译 -------------
  loginPage: {
    loginForm: '用户登录',
    username: '电子邮箱',
    password: '密码',
    code: '谷歌',
    logIn: '登录',
    thirdparty: '或者聯系',
    thirdpartyTips: '本地无法模拟，请结合您自己的业务模拟！ ！ ！'
  },
  application: {
    applicationPanel: '应用程序面板',
    myApplication: '我的应用程序',
    addApplication: '创建应用程序',
    describe1: '还能再创建',
    describe2: '个支付应用',
    describe3: '个',
    logOut: '退出',
    edit: '编辑',
    applicationName: '应用名称 ',
    holder: '请输入应用名称 ',
    status: '状态',
    availableCurrency: '可用货币 ',
    close: '关闭',
    create: '创建',
    save: '保存',
    editApplication: '编辑应用程序',
    type: '平台类型',
    payment: '支付系统',
    ant: '蚂蚁系统'
  },
  header: {
    currentApplication: '当前的应用程序',
    currentTime: '当前时间',
    currentUser: '当前用户'
  },
  dashboard: {
    sort: '序号',
    merchantNo: '商户号',
    productName: '产品名',
    productAccount: '产品账户',
    select: '搜索',
    reset: '重置',
    deposit: '入金',
    withdraw: '出金',
    settlement: '结算',
    balance: '余额',
    abnormalOperation: '异常操作',
    amount: '金额',
    volume: '数量',
    fee: '手续费',
    pendingPayoutAmount: '在途代付金额',
    succeededPayoutAmount: '成功代付金额',
    payoutFee: '代付手续费',
    pendingSettlementAmount: '在途结算金额',
    succeededSettlementAmount: '成功结算金额',
    settlementFee: '结算费用',
    pending_refund_amount: '在途退款金额',
    succeed_refund_amount: '成功退款金额',
    refund_fee: '退款手续费',
    change_refund_order_amount: '修改的退款订单',
    totalAmount: '总金额',
    succeededAmount: '成功的金额',
    totalTransaction: '交易总金额',
    succeededTransaction: '成功交易',
    conversionRate: '兑换率',
    changeDepositOrder: '修改的入金订单',
    changePayoutOrder: '修改的代付订单',
    changeSettlementOrder: '修改的结算订单',
    manualIncreaseBalance: '手动增加余额',
    manualDecreaseBalance: '手动减少余额',
    hint1: '当前时间段没有数据',
    transactionAmountuests: '交易金额',
    rank: '排名',
    productProportion: '入金产品交易统计',
    productAccountProportion: '入金产品账户交易统计',
    totalBalance: '总余额',
    merchantBalance: '商户余额',
    collection: '蚂蚁总余额',
    product_code: '产品名称',
    succeed_amount: '交易金额',
    succeed_volume: '成功笔数',
    succeed_rate: '成功率',
    account_name: '账户名称',
    account_type: '账户类型',
    depositStatistics: '产品统计',
    depositAccountStatistics: '账户统计',
    totalTransact: '交易总数',
    depositStat: '入金统计',
    tooltip: '点击展示更多数据',
    downloadType: '请选择导出的类型',
    depositExport: '入金导出',
    withdrawExport: '出金导出',
    available_balance: '可用余额',
    total_available_balance: '总可用余额',
    subProductList: '子产品统计',
    product_name: '产品名称',
    sub_product_name: '子产品名称',
    contains_sub_products: ' (包含子产品)',
  },
  manager: {
    userName: '用户名 ',
    select: '搜索',
    reset: '重置',
    export: '导出',
    currentDevice: '当前设备',
    OtherDevice: '其他设备',
    managerType: '管理员类型',
    ipWhiteList: 'IP白名单 ',
    placeholder: '请输入IP',
    editIP: '编辑 IP白名单',
    resetIp: '重置 IP白名單',
    availableCurrency: '可用货币 ',
    status: '状态',
    active: '启用',
    disable: '禁用',
    operation: '操作',
    passWord: '密码 ',
    email: '电子邮箱',
    admin: 'admin',
    manager: '管理员',
    send_email: '发送电子邮件',
    login_password_changed: '强制商户修改登录密码',
    withdraw_password_changed: '强制商户修改提现密码',
    yes: '是',
    no: '否',
    merchant_domain: '商户后台域名',
    ant_product_account_group: '蚂蚁代付组',
    checkout_counter_domain: '收银台域名',
    currency_timezone_map: '货币时区',
    taskDescription: '任务描述',
    googleCode: '谷歌代码',
    close: '关闭',
    save: '保存',
    createdBy: '创建者',
    startPlaceholder: '创建开始时间',
    endPlaceholder: '创建结束时间',
    createdTime: '创建时间',
    description: '描述',
    add: '添加 ',
    merchantNo: '商户号 ',
    merchantName: '商户名称 ',
    name: '名称',
    balance: '余额',
    edit: '编辑',
    del: '删除',
    createMerchant: '创建商户 ',
    delMerchant: '删除商户',
    basicInformation: '基本信息 ',
    password: '密码',
    phone: '电话 ',
    pinForWithdraw: '提现密码',
    remarks: '备注',
    introduceAgent: '上级代理',
    modify: '修改',
    safetyInformation: '安全信息',
    merchantKey: '商户密钥',
    depositNotifyURL: '存款通知地址',
    content1: '1. URL 必须以 http 或 https 开头，不允许查询字符串。',
    content2: '2. URL 支持模板变量： ',
    content3: '-merchant_ref（商户订单号），格式为 ',
    content4: '-产品，格式为 ',
    content5: '例如：',
    content6: '假设商家订单号为123456，商品为ThaiQR ',
    content7: 'URL 地址为 https://your_domain.com/path1/',
    content8: '最终请求的地址是 ',
    returnURL: '返回的地址',
    withdrawNotifyURL: '提现通知地址',
    IPWhiteList: 'IP 白名单 ',
    gogleAuth: '谷歌身份验证',
    pass_notify_url: '传参是否携带异步地址',
    allow_merchant_set_IP_whitelist: '商户配置IP白名单',
    cancel: '取消 ',
    createNext: '创建/下一步 ',
    editMerchant: '编辑商户',
    batchEditProduct: '批量修改商户产品配置',
    productManage: '产品管理',
    agentProductManage: '代理产品管理',
    accountsBalance: '账户余额 ',
    settlementAccounts: '结算账户',
    depositOrder: '入金订单',
    payoutOrder: '代付订单',
    settlementOrder: '结算订单',
    manager1: '管理员',
    productList: '产品列表',
    productType: '产品类型',
    productName: '产品名称',
    accountSelect: '查询账户',
    settlementLimit: '结算限额',
    settlement: '单笔金额',
    small_fee: '小额手续费',
    settlementTime: '结算时间',
    depositTime: '入金时间',
    fee: '手续费',
    limits: '单笔限制',
    limit: '限制',
    availableTime: '有效时间',
    merchantProduct: '商户产品',
    productAccount: '产品账号 ',
    currency: '货币',
    tiShi: '该产品没有账户组，请选择其他产品 ',
    tiShi2: '请先选择产品',
    tiShi3: '请选择时间段',
    tiShi4: '请先创建产品账户',
    tiShi5: '该产品没有账户组，请选择其他产品账户',
    productAccountGroup: '产品账户组',
    create: '创建',
    agentProduct: '代理产品',
    agentPrice: '代理价格',
    introducedMerchantsList: '介绍商户列表',
    startTime: '开始时间 ',
    endTime: '时间结束 ',
    depositAmount: '入金金额',
    depositCommission: '入金佣金',
    payoutAmount: '代付金额',
    payoutCommission: '代付佣金',
    settlementAmount: '结算金额',
    settlementCommission: '结算佣金',
    resigersTime: '注册时间',
    rate: '比率',
    settledRebate: '已结算回扣',
    unsettledRebate: '未结算回扣',
    amount: '金额',
    exchangeRate: '汇率 ',
    currentBalance: '当前余额',
    availableBalance: '可用余额',
    outstandingDeposit: '在途入金',
    pendingSettlement: '在途结算',
    pendingPayouts: '在途代付',
    adjustBalance: '调整余额',
    direction: '方向 ',
    decrease: '减少',
    increase: '增加',
    accountsStatement: '账户报表',
    cause: '原因 ',
    orderNumber: '订单号',
    minAmount: '最小金额',
    maxAmount: '最大金额',
    beforeBalance: '之前的余额',
    afterBalance: '之后的余额',
    test_order: '管理员补单',
    pay_time_duration: '支付用时（分钟）',
    sourceIP: '源IP',
    reserve_balance: '保证金',
    reserve_balance_config: '保证金配置',
    reserve_rate:'费率',
    systemRef: '平台订单号',
    createExchangeRate: '创建汇率 ',
    editExchangeRate: '编辑汇率 ',
    basicCurrency: '基本货币 ',
    quoteCurrency: '报价货币',
    mode: '模式',
    bid: '卖价',
    ask: '买价',
    bankAccounts: '银行账户 ',
    information: '信息 ',
    bankAccount: '银行账户 ',

    bankCode: '银行代码',
    accountName: '用户名称',
    accountNo: '账户号',
    volume: '数量',
    created: '创建',
    unpaid: '未付款',
    success: '成功',
    successful: '成功的',
    depositOrderList: '入金订单列表',
    callbackType: '回调类型',
    notifyStatus: '通知状态',
    notifyStartTime: '通知开始时间',
    notifyEndTime: ' 通知结束时间',
    instruction: '操作说明',
    merchantRef: '商户订单号',
    productRef: '产品订单号',
    requestAmount: '请求金额',
    paidAmount: '支付金额',
    productStatus: '产品状态',
    notifiedTime: '通知时间 ',
    pendingAmount: '待交易金额',
    pendingTransaction: '待处理交易',
    successAmount: '成功金额',
    successTransaction: '成功交易',
    freezeAmount: '冻结金额 ',
    freezeTransaction: '冻结交易 ',
    rejectAmount: '拒绝金额',
    rejectTransaction: '拒绝交易',
    payoutOrderList: '代付订单列表',
    source: '来源 ',
    bankName: '银行名称',
    approvedTime: '审批时间',
    settlementOrderList: '结算订单',
    userManagement: '用户管理 ',
    username: '用户名 ',
    noData: '没有数据 ',
    attach: '附加',
    attachEdit: '编辑附加',
    loginLog: '登录日志',
    operation_type: '操作类型',
    change_balance: '调整余额',
    freeze_balance: '冻结余额',
    accountPhone: '账户电话',
    agency: '下级代理',
    refund_min_fee: '退款手续费',
    pending_refund_balance: '在途退款',
    today_pending_settlement_balance: '今日可结算',
    balance_type: '余额类型',
    feeSetting: '手续费设置',
    paymentMethod: '支付方式',
    amountLimit: '金额限制',
    team: 'GCash管理员',
    cardManager: '卡商管理员',
    device_id: '设备 ID',
    os: '系统类型',
    os_version: '系统版本',
    browser: '浏览器名称',
    family: '设备类型',
    brand: '设备品牌',
    location: '地址',
    new: '新设备',
    apply_from: '登陆方式',
    apply_by: '运维管理员',
    belive: '信任此设备',
    device_info: '客户设备',
    Email: '邮箱验证码',
    seconds: '秒后重新获取',
    get_code: '获取验证码',
    card_3d: '信用卡3D',
    hongKongHost: '使用香港Host',
    is_bank: '银行校验',
    card_config: '信用卡限制',
    period: '周期(小时)',
    count: '次数'
  },
  taskCenter: {
    approved_by_name: '审批人',
    select: '搜索',
    reset: '重置',
    export: '导出',
    productName: '产品名称 ',
    createdBy: '创建者',
    approvedBy: '审核者',
    status: '状态',
    startPlaceholder: '创建开始时间',
    endPlaceholder: '创建结束时间',
    handleStartTime: '处理开始时间',
    handleEndTime: '处理结束时间',
    timeType: '时间类型',
    title: '标题',
    description: '描述',
    content: '内容',
    expectStatus: '期望状态',
    approval: '批准',
    approvalMany: '批准许多',
    Reject: '拒绝',
    createdTime: '创建时间',
    lasteTime: '最后活跃时间',
    updateTime: '更新时间',
    successTime: '成功时间',
    approveTime: '审批时间',
    handleTime: '处理时间',
    operation: '操作',
    review: '审核',
    googleQRCode: '谷歌二维码 ',
    download: '下载 ',
    googleCode: '谷歌代碼 ',
    cancel: '取消',
    confirm: '确定',
    fee: '手续费：',
    fee1: '手续费',
    pendingAmount: '待交易金额：',
    pendingTransaction: '待处理交易：',
    successAmount: '成功金额：',
    successTransaction: '成功交易：',
    freezeAmount: '冻结金额： ',
    freezeTransaction: '冻结交易： ',
    rejectAmount: '拒绝金额：',
    rejectTransaction: '拒绝交易：',
    order_number: '订单号',
    child_ordernumber: '出金订单号',
    merchant_no: '商户号 ',
    min_amount: '最小金额',
    max_amount: '最大金额',
    min_coin: '最小链币',
    max_coin: '最大链币',
    source: '来源 ',
    product_account_group: '产品组',
    upstream_status: '产品状态',
    startPlaceholder1: '创建开始时间 ',
    endPlaceholder1: '创建结束时间 ',
    startPlaceholder2: '成功开始时间 ',
    endPlaceholder2: '成功结束时间 ',
    batchPaid: '批量支付',
    openPayfor: '一键代付',
    batchModifyStaus: '批量更改',
    merchantRef: '商户订单号',
    systemRef: '平台订单号',
    depositId: 'ID',
    productRef: '产品订单号',
    amount: '金额',
    information: '信息',
    states: '状态',
    notifyStatus: '通知状态 ',
    notifiedTime: '通知时间 ',
    Approval: '审批',
    callback_amount: '期望金额',
    Change: '更改',
    Query: '查询',
    ChangeOrder: '改变订单状态',
    Details: '详细说明',
    OrderDetails: '订单详情',
    billDetails: '账单详情',
    accountName: '账户名',
    accountNo: '账户号',
    bankCode: '银行代码',
    address: '地址',
    coinType: '硬币类型',
    product: '产品',
    productAccount: '产品账户',
    selectProduct: '请先选择产品 ',
    success: '成功',
    pending: '等待',
    rejected: '被平台拒绝',
    remarks: '备注',
    taskDescription: '任务描述',
    orderInformation: '订单信息',
    merchantsDetail: '商户明细',
    accountsStatnment: '账户报表',
    interfaceInformation: '接口信息 ',
    notify: '通知 ',
    currency: '货币',
    productStatus: '产品状态 ',
    productInformation: '产品信息 ',
    productAccountName: '产品账号名称',
    productAccountNo: '产品账号',
    productAccountType: '产品账号类型 ',
    Upstream: '上游',
    Downstream: '下游',
    notifyURL: '异步回调地址',
    returnURL: '同步回调地址',
    requestTime: '请求时间',
    notifyTime: '通知时间',
    notifyBody: '通知内容',
    request: '请求报文',
    response: '响应报文',
    Key: '字段键值',
    Value: '内容值',
    notifyRequest: '通知请求 ',
    notifyResponse: '通知响应',
    orderNumbers: '订单号',
    withdrawRef: '出金订单号',
    fundInformation: '存款信息',
    rquestAmount: '申请的金额 ',
    paidAmount: '支付的金额',
    Attach: '附加',
    direction: '方向',
    exceptionType: '异常类型 ',
    batchReview: '批量审核 ',
    startId: '起始 ID',
    endId: '结束 ID',
    startHolder: '请输入起始 ID',
    endHolder: '请输入结束 ID',
    type: '类型 ',
    reason: '理由',
    associatedOrderNumber: '相关订单号',
    batchModifyOrderStatus: '批量修改订单状态',
    batchModifyFreezeOrder: '批量修改冻结订单',
    batchOrderNotify: '批量通知',
    openKickOut: '踢出队列',
    message: '消息',
    queryOrder: '查询订单信息',
    orderInfoHolder: '输入商户订单号查询订单详情',
    orderInfoHolder1: '默认按订单金额处理，填写后按期望金额处理',
    noData: '目前没有数据',
    event: '事件',
    selectMethod: '选择处理方式',
    merchantOrder: '回调订单',
    accountBalance: '增加余额',
    merchantNo: '商户号',
    accountStatement: '账户报表',
    action: '处理模式',
    freeze_duration: '冻结持续时间（分钟）',
    instruction: '操作说明',
    reverse_order: '冲正订单',
    reversal: '冲正',
    gateway_url: '网关地址',
    field: '钱包地址',
    range: '金额范围',
    rangeDate: '时间范围',
    queryParams: '查询参数',
    multiple_order_number: '多个订单号',
    multipleOrderTips1: '当前',
    multipleOrderTips2: '个订单号',
    multipleOrderTips3:
      '，添加新的订单号请在当前最后一个订单号后面用英文逗号分割',
    multipleOrderTips4:
      '请将多个订单号在 Excel 或者 TXT 排成一列，然后复制粘贴到该输入框',
    OneClickChange: '一键更改',
    OneClickUnfreeze: '一键解冻',
    multi_child_ordernumber: '多个出金订单号',
    rate: '转化率',
    total_volume: '充值金额',
    total_count: '充值订单',
    uncollect_amount: '未归集金额',
    success_volume: '成功金额',
    success_count: '成功订单',
    childOrder: '子订单',
    withdrawal: '提现设置',
    walletId: '多个钱包 ID',
    refund_order: '入金订单号',
    cap_status: 'CAP 状态',
    mode: '混卡批量审核',
    time: '混卡时间设置'
  },
  product: {
    category: '商户类别代码',
    name: '名称',
    currency: '货币',
    productType: '产品类型',
    product: '产品',
    status: '状态',
    accounts: '账户',
    operation: '操作',
    edit: '编辑',
    del: '删除',
    cashierDeskConfiguration: '收银台配置',
    noData: '当前产品收银台没有可配置项',
    bankDeskConfiguration: '前台银行配置',
    subProduct: '子产品手续费',
    close: '关闭',
    modify: '修改',
    cashierConfig: '添加收银台配置',
    cashierEditConfig: '编辑收银台配置',
    accountType: '账户类型',
    coin_balance: '主链币余额',
    bankCode: '银行代码',
    bnakName: '银行名称',
    logo: '银行图标',
    editProductBank: '编辑产品的银行',
    priority: '优先',
    add: '添加',
    onlineState: '在线状态 ',
    accountNo: '账户号',
    accountName: '账户名称',
    accountGroup: '账户组',
    active: '启用',
    inactive: '未启用',
    block: '锁定',
    wait: '待审核',
    reject: '已驳回',
    approve: '审核通过',
    rejectApprove: '审核驳回',
    disable: '禁用',
    select: '搜索',
    reset: '重置',
    limits: '限制',
    dailyLimitedVolume: '每日限定交易金额',
    availableVolume: '可用交易金额',
    dailyLimitedTransaction: '每日限定交易笔数',
    availableTransaction: '可用交易笔数',
    today_deposit_amount: '今日收款金额',
    margin_balance: '保证金余额',
    hook_start_time: '接单开启时间',
    daily_rate: '成功率',
    matching: '匹配订单',
    hookBalance: '上游余额',
    dedicatedMerchant: '专用商户',
    createProductAccount: '创建产品账户',
    basicInformation: '基本信息 ',
    transaction: '交易',
    statistical: '账户统计',
    productName: '产品名称',
    pollingWeight: '轮询权重',
    collectAddress1: '归集地址',
    collectAddress2: '代付钱包',
    SystemAmount: '系统交易金额',
    manual_amount: '手动金额',
    collect_amount: '归集金额',
    consume: '消耗 TRX',
    abnormal_txn: '异常交易',
    abnormal_txn_count: '异常交易数量',
    productAccountGroup: '产品账户组',
    remarks: '备注',
    back: '后退',
    createNext: '创建/下一步 ',
    configuration: '配置',
    click: '点击',
    info: '查看帮助说明',
    create: '创建',
    clear: '清除',
    saveNext: '保存/下一步 ',
    pleaseSelect: '请选择',
    createWallet: '创建钱包',
    limitation: '限制',
    availableTime: '可用时间',
    selectTimeRange: '请选择时间段',
    limit: '限制',
    queryFrequency: '轮询频率',
    frequencyTips: '开启轮询,默认频率为1分钟',
    save: '保存',
    editAccount: '编辑账户',
    statistics: '统计数据',
    todayVolume: '今日成交量 ',
    todayAvailableVolume: '今日可用量 ',
    todaySuccessTransaction: '今日成功交易 ',
    todaySuccessfulRate: '今日成功率 ',
    totalVolume: '全部成交量',
    totalTransaction: '交易总额 ',
    orderDetails: '订单详细信息 ',
    systemRef: '平台订单号',
    merchantRef: '商户订单号',
    notifyStatus: '通知状态',
    createdStartTime: '创建开始时间 ',
    createdEndTime: '创建结束时间 ',
    merchantNo: '商户号',
    prePayAmount: '预付金额 ',
    paidAmount: '已付金额 ',
    createdTime: '创建时间 ',
    notifiedStatus: '通知状态 ',
    walletAddress: '钱包地址',
    payment_wallet: '付款钱包',
    privateKey: '个人密钥',
    productAccount: '产品账户',
    weight: '轮询权重',
    quanzhong: '请选择产品账户',
    tiShi: '该产品没有账号，请选择其他产品 ',
    hoder: '请输入账户组名 ',
    collectionlog: '钱包地址收集日志 ',
    fromAddress: '从当前地址',
    toAddress: '到当前地址',
    transactionID: '交易编号',
    productRef: '产品订单号',
    message: '消息',
    account_name: '账户名称',
    account_no: '账户号',
    user_id: '设备名称',
    from_val: '来源',
    createtime: '创建时间 ',
    creatingAccountGroup: '创建账户组 ',
    editAccountGroup: '编辑账户组 ',
    amount: '金额',
    uncollectedAmount: '未归集金额 ',
    coinAmount: '未归集主链币金额',
    address: '地址',
    balance: '余额',
    collectionLog: '收集日志',
    extraParam: '产品配置',
    productPluginConfig: '产品插件配置',
    extraParam1: '出金队列',
    extraParam2: 'UPI 超时时间设置',
    extraParam3: '共享代付账户',
    share_payout_account: '开启共享代付账户',
    skipQueue: '不用排队',
    setTimeout: '开启回调超时',
    open: '打开',
    setTime: '超时设置(秒)',
    timeoutTisp: '默认是30分钟，即1800秒',
    frequency: '频率(秒)',
    bill: '每次出金笔数',
    frequency1: '频率(分钟)',
    api_key: 'API Key',
    cannot: '开启状态，频率不能为0',
    not_display_qrcode: '不显示二维码',
    floating_amount: '金额浮动下限',
    not_display_qrcode1: '商户不显示二维码',
    not_display_qrcode2: '应用不显示二维码',
    jump_checkout_counter_mode: '跳转收银台模式 ',
    checkout_counter_mode: '收银台模式',
    server: '服务器 ',
    rate: '比率',
    time: '时间',
    volume: '数量',
    success_volume: '成功订单',
    emptyMerchant: '清空专用商户',
    addApikey: '添加API Key',
    stakeWallet: '自动质押',
    stakeRecord: '手动质押',
    receiver_name: '接收账户',
    resource: '资源',
    energy: '能量',
    bandwidth: '带宽',
    fee_saving: '节约手续费',
    frozen_balance: '质押数量(Trx)',
    freeze: '冻结',
    unfreeze: '解冻',
    unfreezing: '解冻进度',
    isunfreeze: '解冻中',
    unfreeze_percent: '解冻比例',
    cause: '原因',
    buy_unfreeze: '够买解冻',
    buy_unfreeze1: '够买冻结',
    topup_unfreeze: '充值解冻',
    topup_unfreeze1: '充值冻结',
    freeze_percent: '冻结比例',
    totalAmountFreezeend: '总冻结金额',
    expectedThawing: '预计解冻金额',
    expectedFreeze: '预计冻结金额',
    unfreezeend: '已解冻',
    failed: '失败',
    freeze_txn_id: '质押交易 ID',
    unfreeze_txn_id: '解锁交易 ID',
    product_code: '产品',
    product_account_name: '产品账户名',
    createPledge: '创建质押',
    unfreezePledge: '解冻质押',
    unfreeze_time: '解冻时间',
    get: '获得',
    product_detail: '产品详情',
    work_dir: '工作目录',
    Log: '日志',
    program: '进程名称',
    pid: '进程 ID',
    start_plug: '启动',
    reload_plug: '重启',
    stop_plug: '停止',
    unlock_plug: '查询',
    add_btn: '新增',
    apply_view_log: '查看日志',
    change_pin: '修改Pin',
    prompt: '提示',
    otp: 'OTP 验证码',
    otpTips: 'OTP 标识',
    automatic_payment: '自动代付',
    can_withdraw_balance: '可提现金额',
    frozen: '提取冻结金额',
    extract: '提取',
    pledge: '质押',
    agency: '代理',
    accout: '代理账户',
    Address: '代理地址',
    type: '代理类型',
    number: '代理数量(Trx)',
    principal: '可提取的质押本金',
    sleep: '停止查单',
    notify_after_collect: '归集后回调',
    last_collect_time: '上次归集时间',
    change_tiem: '编辑时间',
    amount_timeout: '浮动金额锁 （分钟）',
    review: '蚂蚁账户',
    coin_type: '地址类型',
    active_time: '验证码有效时长（分钟）',
    sms_message: '短信模版',
    note: '注: 短信模版验证码占位符 {{code}}',
    sms_edit: '短信配置',
    expiration_time: '设置过期时间',
    cashier: '设置收银台过期时间',
    queueType: '队列类型',
    unify: '统一排队时间',
    separate: '分开设置时间',
    separateQueues: '分开设置队列',
    utrWeight: 'UTR轮询排序',
    utrWeight1: '请依次选择账户进行排序',
    product_sub_switch: "是否启用",
    product_sub_code: '子产品',
    product_sub_info: '子产品费用详情',
    product_sub_fee: '子产品费用',
    sub_rate: '费率',
    min_fee: '最小费用',
    fixed_fee: '固定费用',
    max_amount: '最大金额',
    min_amount: '最小金额',
    addSubConfig: '添加费率配置',
    delete: ' 删除',
    amount_range_error: '最大金额必须大于等于最小金额',
    amount_continuity_error: '最小金额必须大于前一项的最大金额',
    fee: '手续费',
    subFee: '查看手续费详情',
    gateway_transaction_fee: '网关手续费',
  },
  test: {
    product: '产品',
    productAccount: '产品账户',
    selectProduct: '请先选择产品 ',
    amount: '金额',
    extra: '额外参数',
    merchant: '商户号',
    tips: '请输入商户号',
    tips1: '请选择支付方式',
    tips2: '请选择交易所',
    is_api_integrate: '集成API：1，收银台：0',
    subTips1: 'API 直连模式：',
    subTips2: '必须选择子产品，并填写对应的额外参数。',
    subTips3: '收银台模式：',
    subTips4: '请不要选择子产品。',
  },
  download: {
    relatedSoftware: '相关软件 '
  },
  report: {
    merchantNo: '商户号 ',
    startTime: '开始时间',
    endTime: '结束时间',
    select: '搜索',
    reset: '重置',
    export: '导出',
    date: '日期',
    merchantName: '商户名称 ',
    openingBalance: '期初余额',
    endingBalance: '期末余额 ',
    startingPendingBalance: '开始等待的余额',
    endingPendingBalance: '结束等待的余额',
    type: '类型 ',
    amount: '金额',
    volume: '数量',
    fee: '手续费',
    manualInterventionVolume: '手动干预数量',
    manualInterventionAmount: '手动干预金额',
    manualInterventionTransaction: '手动干预交易',
    begin: '开始',
    end: '结束',
    productName: '产品名称',
    currency: '货币',
    product: '产品',
    transactionVolume: '交易量',
    rebate: '返佣',
    count: '人数',
    level: '等级',

    new_ant_account: '新增账户',
    first_topup_when_register: '注册当日充值账户',
    first_topup_ant_account_when_register: '注册当日充值金额',
    active_ant_account: '活跃账户',
    topup_ant_account: '当日充值账户',
    topup: '当日充值金额',
    first_topup_ant_account: '首充账户',
    first_topup: '首充金额',
    withdraw: '提现金额',
    sale_usdt: '销售金额',
    invitation_rebate: '好友返佣',
    sale_profit: '销售收益',
    succeed_deposit_amount: '商户入金',
    deposit_fee: '入金手续费',
    succeed_deposit_volume: '入金成功笔数',
    succeed_payout_amount: '商户出金',
    payout_fee: '出金手续费',
    succeed_payout_volume: '出金成功笔数',
    balance: '商户总余额',
    active_agent: '活跃代理账户',
    new_descendant: '下级注册账户',
    descendant_first_topup_count: '下级新充账户',
    descendant_first_topup_amount: '下级新充账户金额',
    create_time: '创建时间',
    exchange: '兑换数据',
    upper: '上分数据',
    risk: '风险控制',
    nickname: '发图人昵称',
    coin_id: '安币 ID',
    upper_limit: '上分上限',
    unit_quantity: 'U数量',
    rupee_quantity: '卢比数量',
    exchange_rate: '汇率',
    pay_type: '支付方式',
    name: '卖家姓名',
    order_time: '订单时间'
  },
  setting: {
    manageBackEndDomain: '管理员管理域名',
    merchantBackEndDomain: '商户端域名',
    checkoutCounterDomain: '收银台域名',
    modify: '修改',
    siteName: '网站标题',
    siteLogo: '网站 Logo',
    testMerchantNo: '测试商户号',
    googleAuthentication: '谷歌身份验证',
    botGoogleAuthentication: '机器人谷歌验证',
    addExchangeRate: '创建汇率',
    baseCurrency: '基础货币',
    quoteCurrency: '报价货币',
    mode: '模式',
    bid: '卖价',
    ask: '买价',
    operation: '操作',
    edit: '编辑',
    delete: '删除 ',
    back: '取消',
    save: '保存',
    cancel: '取消',
    create: '创建',
    editMerchantNo: '编辑商户号 ',
    taskDescription: '任务描述',
    editCheckoutCounterDomain: '编辑收银台域名 ',
    editExchangeRate: '编辑汇率 ',
    notify_switch: '代付声效开关',
    auto_refund: '自动退款开关',
    ant_payout_payment_switch: '蚂蚁代付抢单',
    notify_withdraw_switch: '出金审查任务通知',
    notify_usdt_collect_switch: 'USDT 通知开关',
    thai_notify_switch: 'Thai 通知开关',
    inr_notify_switch: 'INR 通知开关',
    php_notify_switch: 'PHP 通知开关',
    eur_notify_switch: 'EUR 通知开关',
    ngn_notify_switch: 'NGN 通知开关',
    rm_notify_switch: 'RM 通知开关',
    safety_notify_switch: '安全通知开关',
    gcash_notify_switch: 'GCash 防盜刷通知开关',
    gcashTgTitle: 'Telegram GCash 防盗刷通知',
    usd_cap_notify_switch: 'CAP 异常通知',
    usd_cap_notify_telegram_group: 'Telegram CAP 异常通知',
    ant_limit_notify_switch: '蚂蚁上分上限通知',
    ant_register_notify_switch: '蚂蚁注册通知',
    ant_limit_notify_telegram_group: 'Telegram 蚂蚁上分上限通知',
    addGroup: '添加 Telegram 通知群组',
    payTgTitle: 'Telegram 代付通知',
    usdtTgTitle: 'Telegram USDT 通知',
    thaiTgTitle: 'Telegram Thai 通知',
    inrTgTitle: 'Telegram INR 通知',
    phpTgTitle: 'Telegram PHP 通知',
    eurTgTitle: 'Telegram EUR 通知',
    ngnTgTitle: 'Telegram NGN 通知',
    groupId: 'Telegram 群ID',
    inputGroupId: '请输入群ID',
    inputGroupId1: '请输入群ID、账户类型（使用英文分号间隔）',
    inputQueryId: '请输入群名称查询群ID',
    queryBtn: '查询',
    telegram_devops_robot_token: 'Telegram 运维机器人 Token',
    telegram_robot_token: 'Telegram 客服机器人 Token',
    setTimeZone: '货币时区',
    tab1: '系统设置',
    tab2: '运维机器人',
    tab3: '客服机器人',
    tab4: '基础设置',
    tab5: '返佣设置',
    tab6: '推荐返佣',
    tab7: '账户转发',
    tab8: 'FP机器人',
    ant_withdraw_max_order_count: '蚂蚁抢单限制数',
    ant_withdraw_expire_min: '蚂蚁抢单失效时间(分钟)',
    buy_usdt_rate: 'Buy USDT 汇率',
    rateBuyLog: 'Buy USDT 汇率设定',
    buy_freeze: 'Buy 冻结设置',
    sale_usdt_rate: 'Sale USDT 汇率',
    exchange_usdt_rate: 'Exchange USDT 汇率',
    exchange_usdt_rebate_freeze_time: '承兑本金冻结',
    rateExchangeLog: 'Exchange USDT 汇率设定',
    rateSakeLog: 'Sale USDT 汇率设定',
    baseFreeze: '代收本金冻结',
    baseFreezeLog: '防止用户在没有成交代付的情况，冻结金额（小时)',
    exchangeFreezeLog: '防止用户在没有成交承兑的情况，冻结金额（小时)',
    sale_usdt_rebate_rate: 'Sale USDT返佣',
    buy_usdt_rebate_rate: 'Buy USDT返佣',
    sale_rebate_freeze_time: 'Sale USDT佣金冻结时间',
    buy_rebate_freeze_time: 'Buy USDT佣金冻结时间',
    exchange_usdt_rebate_rate: 'Exchange USDT返佣',
    exchange_rebate_freeze_time: 'Exchange USDT佣金冻结时间',
    rebateRateLog:
      '订单交易成功后给上级返佣的比例0 - 100，例：5=反订单金额的5%',
    rebateRateAnt:
      '订单交易成功后给蚂蚁返佣的比例0 - 100，例：5=反订单金额的5%',
    freezeTime: '佣金冻结时间',
    in_maintain: '不可用银行',
    freezeTimeLog: '防止用户退款，佣金提现了，所以需要设置佣金冻结时间（天）',
    yiji: '一级返佣比例',
    erji: '二级返佣比例',
    sanji: '三级返佣比例',
    safety: '安全通知开关',
    safetyTg: 'Telegram 安全通知',
    kefu_link: '客服链接',
    topup_freeeze: '充值冻结',
    wallet_reset_duration: '充值地址使用时长（年）',
    register_switch: '注册开关',
    register_apply_switch: '注册审核开关',
    notAllowed: '不允许注册',
    allow: '允许注册',
    notNeed: '不需要审核',
    need: '需要审核',
    close_buy: '代付功能',
    ant_trc20: 'TRC20 控制开关',
    ant_erc20: 'ERC20 控制开关',
    ant_inr: 'INR 控制开关',
    wallet_delete_switch: '删除账户',
    test_order_notify_switch: '测试订单通知',
    telegram_account_switch: '消息转发',
    fee: '提现手续费',
    trc_fee: 'TRC20 提现手续费',
    erc_fee: 'ERC20 提现手续费',
    clave_notify_switch: 'Clave 识别',
    buy_platform_usdt_rate: '法币买U汇率',
    buy_platform_usdt_min_amount: '法币买U最低金额',
    merchant_deposit_settlment_rate: '商户入金汇率',
    merchant_payout_settlment_rate: '商户代付汇率',
    merchant_exchange_settlment_rate: '商户承兑汇率',
    ant_google_auth: '蚂蚁提现谷歌验证',
    open: '开启验证',
    close: '关闭验证',
    send: '发送密钥',
    reset: '重置密钥',
    photo: '图片识别',
    asyn_photo_switch: '异步图片识别',
    api_error_switch: 'API报错通知',
    api_sms_switch: 'SMS 通知',
    rm_deposit_notify_switch: 'RM 代收开关',
    rm_payout_notify_switch: 'RM 代付开关',
    rm_collect_notify_switch: 'RM 归集开关',
    score: '上分识别',
    cars_switch: '混卡模式',
    bot_cars_switch: '混卡模式',
    bot_cars_setting: '上分时间段设置',
    bot_cars_edit: '上分时间段编辑',
    app_setting: 'APP系统通知',
    choose_ant: '蚂蚁账号',
    content: '通知内容',
    send_content: '发送通知',
    record: '通知记录',
    switch: '开关',
    off: '不开启',
    required: '必填',
    optional: '选填',
    account_rate_notify_switch: '账户成功率骤降通知',
    bot_cert_style: '凭证样式',
    merchant_no_list: '商户组',
    merchantPlaceholder: '支持多个商户号，英文逗号分割',
    errorMessage: '格式有误，也许是因为使用了不正确的英文逗号，请检查',
    delicacy: '精致',
    simple: '简约',
    change_style: '修改凭证样式',
    holiday: "节假日结算延期",
    days: '天数',
    holidayConfig: '添加节假日延期结算配置',
    holidayName: '节假日名称',
    fp_robot_token: 'FP 机器人 Token',
    fp_bot_switch: '查单开关',
    exchange_switch: '换汇开关',
    fp_chat_id: '群ID',
    fp_exchange_markup: '汇率',
    fp_merchant_id: '商户ID',
    fp_merchant_app_id: 'APP ID',
    fp_merchant_api_key: 'API Key',
    payout_risk_duplicate_account_switch: '风控开关',
    payout_risk_duplicate_account_window_hours: '收款账号重复出金（小时）',
    payout_risk_duplicate_account_max_count: '收款账号重复次数',
    merchant_login_google_auth_switch: '商户登录谷歌验证',
    merchant_backoffice_payout_switch: '商户后台代付/结算开关'
  },
  order: {
    total: '全部',
    today: '今天',
    succeedRequestAmount: '成功请求金额',
    Withdrawal: '出金审查',
    succeedVolume: '成功订单',
    succeedPaidAmount: '成功支付金额',
    volume: '总订单',
    fee: '手续费',
    conversionRate: '转化率',
    auth_code: '授权码',
    last4: '卡后4位',
    orderNumber: '订单号',
    merchantNo: '商户号',
    instruction: '操作说明',
    paidAmount: '支付金额',
    requestAmount: '请求金额',
    a: '余额',
    b: '链币余额',
    minAmount: '最小金额',
    maxAmount: '最大金额',
    productName: '产品名称',
    productAccount: '产品账户',
    status: '状态',
    notifyStatus: '通知状态',
    timeType: '时间类型 ',
    createdTime: '创建时间',
    notifyTime: '通知时间',
    successTime: '成功时间',
    error_notify: '错误通知',
    upstream_data: '上游数据',
    type: '接口请求',
    data: '报文',
    view: '查看',
    allTime: '创建/成功时间',
    unfreezeTime: '解冻时间',
    createdStartTime: '创建开始时间 ',
    createdEndTime: '创建结束时间 ',
    notifyStartTime: '通知开始时间',
    notifyEndTime: '通知结束时间',
    successStartTime: '成功开始时间 ',
    successEndTime: '成功结束时间',
    unfreezeStartTime: '冻结开始时间',
    unfreezeEndTime: '冻结结束时间',
    select: '搜索',
    reset: '重置',
    export: '导出',
    merchantRef: '商户订单号',
    systemRef: '平台订单号',
    productRef: '账户订单号',
    productStatus: '产品状态',
    operation: '操作',
    change: '修改',
    details: '详情',
    more: '更多',
    orderDetails: '订单详情',
    changeOrders: '修改订单',
    expectStatus: '期待状态 ',
    payTime: '支付时间 ',
    selectDate: '请选择日期 ',
    remarks: '备注',
    taskDescription: '任务描述',
    cancel: '取消 ',
    save: '保存',
    createdBy: '创建者',

    orderInformation: '订单信息',
    billInfo: '账单信息',

    notify: '通知',
    currency: '货币',
    collectStatus: '收集状态',
    productInformation: '产品信息',
    product: '产品',
    productAccountName: '产品账户名',
    productAccountNo: '产品账户号',
    productAccountType: '产品账户类型',
    interfaceInformation: '接口信息',
    upstream: '上游',
    downstream: '下游',
    notifyURL: '异步回调地址',
    returnURL: '同步回调地址',
    requestTime: '请求时间',
    notifyBody: '通知内容',
    requestBody: '请求报文',
    key: '字段键值',
    value: '内容值',
    responseBody: '响应报文',
    notifyRequestBody: '通知请求报文',
    notifyResponseBody: '通知响应报文',
    collectionLog: '收集日志',
    receipt: '交易收据',
    issueddate: '发行日期',
    paiddate: '支付日期',
    debitAccount: '借记账户',
    creditAccount: '信用账户',
    utfNo: 'UTR 号',
    payment: '支付金额',
    payStatus: '支付状态',
    transactionStatus: '交易状态',
    REMARKS: '备注',
    receiptName: '名称',
    close: '关闭',
    print: '打印',
    createTime: '创建时间',
    message: '消息',

    pendingAmount: '在途金额',
    pendingTransaction: '在途交易',
    successAmount: '成功金额',
    successTransaction: '成功交易',
    freezeAmount: '冻结金额',
    freezeTransaction: '冻结交易',
    rejectAmount: '拒绝金额',
    rejectTransaction: '拒绝交易',
    information: '信息',
    approvedBy: '审批者',
    success: 'Success',
    pending: 'Pending',
    rejectedPlatform: 'Rejected By Platform',
    source: '来源',
    amount: '金额',
    refundAmount: '退款金额',
    approvedTime: '审批时间',
    notifiedTime: '通知时间',
    refundTime: '退款时间',
    bankCode: '银行代码',
    request: '请求',
    response: '响应',
    accountName: '账户名',
    accountNo: '账户号',
    withdrawInfo: '出金信息 ',
    bankName: '银行名称',
    logDetails: '请求日志详情',
    notifyRequest: '回调请求',
    notifyResponse: '回调响应',
    withdrawRef: '出金订单号',
    query: '查询',
    enqueue: '排队',
    migrateBtn: '应用审查',
    migrateTit: '应用审查',
    notify_ordernumber: '下游订单号',
    upstream_ordernumber: '上游订单号',
    product_account_no: '账户号',
    test_order: '测试订单',
    kaaz_bank: '银行校验查询',
    info: '充值信息',
    setCollect: '归集设置',
    collect_wallet: '归集账户',
    fee_wallet: '手续费钱包',
    fee_limit: '手续费限制',
    min_collect_amount: '最低归集金额',
    collect_by_stake: '质押归集开关',
    google_code: 'Google 验证码',
    setting: '充值设置',
    USDTBlance: 'USDT 余额',
    money_type: '钱包类型',
    saleAmount: '销售金额',
    commission: '佣金',
    address: '收款地址',
    gas: 'Gas 价格',
    price: '矿工费标准',
    refund: '退款金额',
    fiat_amount: '法币金额',
    set_usdt: '结算金额',
    settlement_merchant_rate: '商户汇率',
    settlement_rate: '蚂蚁汇率',
    prepay: '成功法币金额',
    settlement_amount: '回购金额',
    payment_card_type: '卡类型',
    card_last6: '卡号后6位',
    not: '未发起',
    pend: '发起中',
    initiate: '发起CAP',
    cap: '只有订单状态为成功且CAP状态未发起或失败的订单才可进行CAP操作',
    ok: '确认',
    total_transaction: '总笔数',
    total_successful_rate: '总成功率',
    no_notify: '未通知',
    yes_notify: '已通知',
    upstream_amount: '承兑金额',
    ordernumber: '承兑订单号',
    refundRemarks: '退款原因',
    refundHolder: '请输入退款金额',
    refundHolder1: '请详细说明退款原因',
    attention: '退款须知：',
    attention1: '可退款金额不能超过订单金额',
    attention2: '已结算订单将从商户余额扣除',
    attention3: '退款申请提交后无法撤销',
  },
  title: {
    share: '分享账户'
  },
  antManage: {
    accountId: '账户ID',
    EmailNickname: '邮箱/昵称',
    email: '邮箱',
    type: '类型',
    balance: '保证金余额',
    state: '状态',
    ancestor: '主账户',
    password: '密码',
    create: '创建',
    modifyBalance: '余额',
    buy_freeze_balance: '够买冻结',
    quota: '配额',
    subaccount: '子账户',
    details: '详情',
    amount: '金额',
    remarks: '备注',
    inOrOut: '增加或减少',
    attach: '图片附件',
    operation: '操作类型',
    people: '个人资料',
    statistics: '数据统计',
    nickname: '账户ID / 账户昵称',
    invitation_code: '邀请码',
    transaction: '交易明細',
    collection: '好友列表',
    salesAmount: '销售金额',
    cause: '明细类型',
    detailId: '明细ID',
    ordernumber: '系统订单号',
    before_balance: '变动前余额',
    after_balance: '变动后余额',
    create_time: '创建时间',
    ip: '源IP',
    trader: '交易员',
    master: '主账户',
    sub: '子账户',
    payType: '支付方式',
    outStutus: '离线',
    online: '在线',
    control: '风控',
    full: '满额',
    decrease: '减少',
    increase: '增加',
    from_ant: '转出账户',
    to_ant: '转入账户',
    change_balance: '调整余额',
    upstream_remarks: '订单介绍',
    fee: '手续费',
    paid_amount: '支付金额',
    successful_rate: '成功率',
    successful_transaction: '成功笔数',
    total_transaction: '总使用额度',
    volume: '使用额度',
    registered: '注册用户',
    onlineUser: '在线用户',
    last_login_time: '上次登录时间',
    last_login_ip: '最近登录 IP',
    last_login: '最后登录时间',
    profit: '收益',
    rebate: '好友返佣',
    collect: '销售金额',
    freeze: '冻结',
    payment: '购买',
    withdraw: '提现',
    topup: '充值',
    topup1: '充值金额',
    settlement_address: '结算地址',
    topup_address: '充值地址',
    available: '可用余额',
    pending_deposit_balance: '保证金',
    pending_payout_balance: '在途代付',
    freeze_balance: '在途返佣',
    manager_freeze_balance: '管理员冻结',
    ancest: '上级',
    descendant: '下级',
    select: '请选择上下级',
    one: '一级下属',
    two: '二级下属',
    three: '三级下属',
    level: '等级',
    buy: '购买',
    sale: '出售',
    account: '账户列表',
    rate: '返佣比例',
    sale_status: '代收状态',
    sale_on: '开启代收',
    manual_change_balance: '管理员操作',
    sale_collection: '销售',
    ant_id: '蚂蚁ID',
    start_sale: '开启销售',
    stop_sale: '停止销售',
    account_ids: '产品账户',
    topup_transaction: '充U次数',
    buy_u_topup: '法币买U',
    buy_u_topup_transaction: '法币买U次数',
    topup_u_total: '充U总额',
    success_rate: '成功率',
    sale_transaction: '成功订单',
    sale_order_count: '销售接单',
    unlock: '解锁',
    lock: '锁定',
    freezeBalance: '冻结保证金',
    Balance: '保证金余额',
    backstage: '蚂蚁后台',
    friend_setting: '好友设置',
    close_self_rebate: '关闭接单佣金',
    close_friend_rebate: '关闭好友返佣',
    open_self_rebate: '开启接单佣金',
    open_friend_rebate: '开启好友返佣',
    recommender: '上级好友',
    deposit_balance: '冻结金额',
    negative_balance: '负余额',
    manager_freeze: '充值冻结',
    recently: '最近',
    last: '上次',
    previous: '前次',
    is_low_rating: '低评分',
    manage_freeze_balance: '充值冻结金额'
  },
  gcash: {
    search: '搜索内容',
    onlie_status: '在线状态',
    account_status: '账户状态',
    account_id: '账户编码',
    phone_number: '手机号',
    sms_id: '短信转发器ID',
    kyc_grade: 'KYC 等级',
    remain_money: '余额(PHP)',
    account_info: '账户信息',
    order_num: '收款笔数',
    money_num: '收款金额',
    addAccount: '创建账户',
    editAccount: '编辑账户',
    gcash_groups: '分组',
    accountInfo: ' 账户详情',
    basic: '基本信息',
    collectionLog: '收款账单',
    paymentLog: '代付账单',
    smsLog: '短信账单',
    actionLog: '操作日志',
    ref_num: '订单标识',
    pay_type: '类型',
    collection: '代收',
    payment: '代付',
    textMessage: '短信',
    from_name: '付款账户',
    to_name: '收款账户',
    money: '付款金额',
    messages: '回调来源',
    duanxin: '短信内容',
    open_date: '日期',
    open_time: '时间',
    status: '状态',
    note: '备注',
    batchDel: '批量删除',
    batchBulk: '批量转账',
    isDetele: '是否永久删除以上账户',
    formPhone: '转出账户',
    toPhone: '转入的手机号',
    phone: '转入账户手机号',
    groupManagement: '分组管理',
    groupName: '分组名称',
    openOnePay: '转账',
    balanceQuery: '批量余额查询',
    batchLogin: '批量登录',
    upExcel: 'Excel 批量上传账号',
    smsId: '短信转发器 ID',
    wait: '待转账',
    fail: '失败',
    success: '成功',
    twice: '二次验证成功',
    ordinaryTransfer: '普通转账',
    bankTransfer: '银行转账',
    bank_name: '银行名称',
    bank_code: '银行编号',
    dst_accno: '银行卡账号',
    dst_accname: '银行卡账户名',
    grouping: '批量分组',
    all_group: '以上账户是否全部转入该分组',
    code: '（编码）',
    content: '内容',
    uploader: '上传 excel 文件',
    invite_login: '邀请登录',
    bank_co: '银行编码',
    sign_up: '上号',
    invite_up: '邀请上号',
    batch_up: '批量上号',
    account: '在线账户',
    check: '账单',
    gathering: '收款',
    anotherPay: '代付',
    withdrawal: '手动出款',
    last: '最后上号',
    daily_limit: '可用付款日限额',
    monthly_limit: '可用收款月限额',
    balance_limit: '余额上限',
    team: '团队',
    login: '登录 OTP 验证'
  },
  payee: {
    info: '全球付款',
    paymentType: '收款人账户类型',
    type1: '个人',
    type2: '企业',
    area: '收款账户所在地区',
    currency: '收款货币',
    paymentMethod: '付款方式',
    upstreamAmount: '到账金额',
    address: '收款人地址',
    feeType: '手续费类型',
    title1: '国际银行转账方式，需提供：SWIFT号、银行账号',
    title4: '本地银行转账方式，需提供：本地路径清算号（或SWIFT号）、银行账号',
    title2:
      '时效:常规处理时效0-7个工作日(如遇到合规审查/技术维护/银行故障不可抗力等因素，会有部分延迟)',
    title3:
      '时效:常规处理时效0-3个工作日(如遇到合规审查/技术维护/银行故障不可抗力等因素，会有部分延迟)'
  },
  appSoftware: {
    search: '软件搜索',
    name: '软件名称',
    type: '软件分类',
    order: '收单产品',
    download: '安装',
    noapp: '当前标签没有应用软件。',
    edit: '软件详情',
    sort: '排序权重',
    status: '插件状态',
    tag: '插件类型',
    apply: '应用标签',
    classify: '分类标签',
    inactive: '未安装',
    active: '已安装',
    pendingBalance: '在途入金',
    ordernumber: '系统订单',
    upstream_ordernumber: '上游订单',
    amount: '支付金额',
    before_balance: '变动前余额',
    after_balance: '变动后余额',
    balanceStatus: '余额状态',
    add: '加钱',
    deduct: '扣钱',
    cause: '原因',
    deposit_balance: '在途入金',
    payout_balance: '在途出金',
    appInfo: '软件详情',
    fundInfo: '资金明细',
    payoutBalance: '在途代付',
    action: '结算代付类型',
    setting: '丢弃原因设置',
    create: '创建放弃原因',
    label: '标签',
    value: '传递的 KEY',
    actionDetail: '蚂蚁订单的操作',
    file_url: '完成订单转账截图',
    ant_status: '期望状态',
    order_status: '代付订单状态',
    reject: '驳回',
    ant_action: '蚂蚁操作',
    picture: '查看图片',
    finish: '支付完成',
    abandon: '丢弃订单',
    ant_order_no: '银行单号',
    payment: '平台账户',
    approval: '审批操作',
    go: '通过',
    padding: '等待抢单',
    today_deposit_time: '入金查询时间'
  },
  card: {
    user_name: '卡商名称',
    name: '卡商账户',
    cardManager: '卡商管理员',
    balance: '余额',
    transaction: '交易量',
    addCard: '创建卡商账户',
    config: '卡商账户设置',
    relevance: '关联账户',
    account: '产品账户',
    accountName: '账户',
    totalAmount: '交易量',
    successRate: '成功率',
    count: '笔数',
    balanceList: '余额记录',
    increaseBalance: '增加余额',
    relevanceAccount: '关联产品账户',
    balanceChange: '余额变动',
    cardName: '卡商',
    money: '金额',
    operate: '操作',
    add: '增加',
    reduce: '减少'
  },
  sms: {
    sms_account: '短信账户',
    merchant_balance: '商户余额',
    sms_logs: '短信记录',
    account: '账号',
    status: '状态',
    enable: '启用',
    noenable: '未启用',
    balance: '余额',
    gift_balance: '赠送余额',
    merchant_no: '商户号',
    name: '名称',
    sms_balance: '短信余额(USDT)',
    sms_balanc: '短信余额',
    sms_id: '短信ID',
    send_mobile: '接收号码',
    success: '成功',
    fail: '失败',
    sms_message: '短信内容',
    send_time: '发送时间',
    addsmsAccount: '创建短信账户',
    editsmsAccount: '编辑短信账户',
    ref_no: '标识',
    amount: '金额',
    remark: '备注',
    ip_address: '源IP',
    account_number: '账号',
    password: '密码',
    price: '价格(USDT)',
    send_status: '发送状态',
    send_state0: '发送成功',
    send_state1: '未发送',
    send_state2: '发送中',
    send_state3: '发送失败',
    delivery_status: '送达状态',
    delivery_status0: '不报告',
    delivery_status1: '已发送未送达',
    delivery_status2: '送达失败',
    delivery_status3: '送达成功',
    delivery_status4: '送达超时',
    delivery_status5: '未知',
    smsSwitch: '短信开关',
    failed_sent: '发送失败',
    success_rate: '成功率(%)',
    success_sent: '发送成功',
    total_cost: '总费用(USDT)',
    total_sent: '总发送'
  }
}
